import { bool, object } from "prop-types";
import { TABLE_DRAGGABLE_CONTAINER } from "@utils";
import { ValueCell, useEstimateEditorSettings, useEstimateTableSettings } from "@tools";
import { SortableListV2 } from "@components";
import Grid from "@material-ui/core/Grid";
import { CombinedHeaderWorkType, HeaderWorkType } from "./components";
import classnames from "classnames";

export const TaskEstimatesCell = ({
  section,
  extendPadding,
}) => {
  const { allowEdition, isProposal } = useEstimateEditorSettings();
  const { visibleWorkTypes, emptyWorkTypeCells } = useEstimateTableSettings();
  
  const { showCombinedHours } = section;
  
  const handleWorkTypeReorder = (list) => {
    section.reorderWorkTypes(list);
  }
  
  return (
    <Grid
      className={ classnames(TABLE_DRAGGABLE_CONTAINER, "wt-container cell") }
      item
      container
      wrap="nowrap"
      alignItems="center"
      style={ { width: "initial" } }
    >
      {
        !showCombinedHours && emptyWorkTypeCells > 0 &&
        [...new Array(emptyWorkTypeCells).keys()].map((i) => (
          <ValueCell key={`placeholder${i}`} size="small" />
        ))
      }
      {
        !showCombinedHours &&
        <SortableListV2
          list={ visibleWorkTypes }
          group="breakdown-systems"
          onListReorder={ handleWorkTypeReorder }
          disabled={ !allowEdition }
          horizontal
          lockAxis
        >
          {
            visibleWorkTypes?.map(( workType, index, list ) => (
              <HeaderWorkType
                key={workType.id}
                id={workType.id}
                workType={ workType }
                section={ section }
                extendPadding={extendPadding && index === list.length-1}
              />
            ))
          }
        </SortableListV2>
      }
      {
        showCombinedHours && visibleWorkTypes.length > 0 &&
        <CombinedHeaderWorkType
          section={ section }
          isProposal={isProposal}
          // extendPadding={extendPadding}
        />
      }
    </Grid>
  )
}

TaskEstimatesCell.propTypes = {
  section: object.isRequired,
  extendPadding: bool,
}